import {eventBus} from "../core/event-bus-store.js";
import {writable} from "svelte/store";

export const editDetailsHalfScreen = writable({
    opened: false,
    record: undefined,
    showCartPreview: false,
    showModsSelector: true,
    showAddButton: true
});

export const openEditDetailsHalfScreen = (record, mode) => {

    editDetailsHalfScreen.update(x => {

        x.opened = record !== undefined;
        x.record = record;

        if (mode === 'addItems') {
            x.showCartPreview = false;
            x.showModsSelector = true;
            x.showAddButton = true;
        }
        else if (mode === 'removeItems') {
            x.showCartPreview = true;
            x.showModsSelector = false;
            x.showAddButton = false;
        }

        return x;
    });
};

export const closeEditDetailsHalfScreen = () => {

    editDetailsHalfScreen.update(x => {

        x.opened = false;
        x.record = undefined;
        x.mode = undefined;

        return x;
    });
};


eventBus.subscribe(events => {

    try {
        for (let i = 0; i < events.length; i++) {
            const e = events[i];
            if (e.event === 'openEditDetailsHalfScreen' && e.payload?.record && e.payload?.mode) {
                openEditDetailsHalfScreen(e.payload.record, e.payload.mode);
            }

            if (e.event === 'closeEditDetailsHalfScreen') {
                closeEditDetailsHalfScreen();
            }
        }
    }
    catch (e) {
        console.error(e);
    }
});

